import { combineReducers } from 'redux';

import {
  OPEN_PLATFORM_PARTNER_CONSENT_SET_PARTNER_DETAIL,
  OPEN_PLATFORM_PARTNER_CONSENT_SET_ACTION_ALLOW,
  OPEN_PLATFORM_PARTNER_CONSENT_SET_ACTION_DENY,
  OPEN_PLATFORM_PARTNER_CONSENT_SET_ACTION_ERROR,
  OPEN_PLATFORM_PARTNER_CONSENT_SET_ERROR_MESSAGE,
  OPEN_PLATFORM_PARTNER_CONSENT_RESET_ERROR_MESSAGE,
  OPEN_PLATFORM_PARTNER_CONSENT_RESET,
} from '../../actions/openPlatform/partnerConsent/constants';
import createReducer from '../../utils/createReducer';
import { ALLOW, DENY, ERROR } from '../../constants/partnerConsent';

const partnerDetail = createReducer(
  {
    id: '',
    name: '',
    scopes: [],
    logo: '',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    redirect_uri: '',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    is_registered: false,
  },
  {
    [OPEN_PLATFORM_PARTNER_CONSENT_SET_PARTNER_DETAIL]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.partnerDetail,
    [OPEN_PLATFORM_PARTNER_CONSENT_RESET]: () => ({
      id: '',
      name: '',
      scopes: [],
      logo: '',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      redirect_uri: '',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      is_registered: false,
    }),
  }
);

const action = createReducer('', {
  [OPEN_PLATFORM_PARTNER_CONSENT_SET_ACTION_ALLOW]: () => ALLOW,
  [OPEN_PLATFORM_PARTNER_CONSENT_SET_ACTION_DENY]: () => DENY,
  [OPEN_PLATFORM_PARTNER_CONSENT_SET_ACTION_ERROR]: () => ERROR,
});

const errorMessage = createReducer('', {
  [OPEN_PLATFORM_PARTNER_CONSENT_SET_ERROR_MESSAGE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.errorMessage,
  [OPEN_PLATFORM_PARTNER_CONSENT_RESET_ERROR_MESSAGE]: () => '',
});

export default combineReducers({
  partnerDetail,
  action,
  errorMessage,
});
